import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import goldenULogo from "../assets/images/maxtronlogo.png";

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const { pathname } = useLocation();
  const navRef = useRef(null);

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 0);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    setIsMobileMenuOpen(false);
  }, [pathname]);

  const navItems = ["About Us", "Industries", "Case Studies", "Contact Us"];

  return (
    <nav
      ref={navRef}
      className={`
        rounded-full 
        ${
          isSticky
            ? "fixed top-0 left-0 right-0 z-50 bg-[#1A1A1A] transform transition-all duration-300 ease-in-out mx-4 sm:mx-2 md:mx-6 lg:mx-8 mt-4 sm:mt-6 shadow-[0_0_15px_rgba(210,180,140,0.2)]"
            : "relative mx-4 sm:mx-2 md:mx-6 lg:mx-8 mt-4 sm:mt-6 bg-[#1A1A1A] shadow-[0_0_15px_rgba(210,180,140,0.1)]"
        }shadow-[0_4px_10px_rgba(0,0,0,0.25),inset_0_0_10px_rgba(192,192,192,0.05)]"
        }
      `}
    >
      <div className="max-w-screen-2xl mx-auto px-6">
        <div className="flex items-center justify-between h-24">
          <div className="max-w-7xl mx-auto flex justify-between w-full items-center">
            <div className="flex-shrink-0">
              <Link to="/">
                <img
                  className="h-16 w-auto sm:h-20"
                  src={goldenULogo}
                  alt="Maxtron Logo"
                />
              </Link>
            </div>

            <div className="hidden lg:flex items-center space-x-6 xl:space-x-10">
              {navItems.map((item, index) => (
                <span
                  key={index}
                  className="flex items-center px-2 xl:px-3 py-2 rounded-md text-2xl font-medium text-white hover:text-[#D4AF37] cursor-default transition-colors duration-150 ease-in-out"
                >
                  {item}
                </span>
              ))}
            </div>

            <div className="hidden lg:flex items-center">
              <button
                className="text-[#D4AF37] focus:outline-none p-3 rounded-md text-24"
                aria-label="Select Language"
              >
                <svg
                  width="35"
                  height="30"
                  viewBox="0 0 42 41"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M37.1697 8.20691C34.6027 4.99547 31.095 2.62473 27.1138 1.4106C23.133 0.196467 18.8678 0.196467 14.8862 1.4106C10.9054 2.62473 7.3973 4.99556 4.83034 8.20691C2.02401 11.7181 0.5 16.0453 0.5 20.5C0.5 24.955 2.02401 29.2819 4.83034 32.7932C7.39691 36.0042 10.905 38.375 14.8862 39.5891C18.8674 40.8036 23.1326 40.8036 27.1138 39.5891C31.095 38.375 34.6027 36.0042 37.1697 32.7932C39.9756 29.2816 41.5 24.9548 41.5 20.5C41.5 16.0454 39.9756 11.7182 37.1697 8.20691ZM36.4099 31.2787C35.0548 30.23 33.5904 29.3245 32.0407 28.5764C32.8781 26.2192 33.3418 23.7508 33.4161 21.257H39.9888C39.8391 24.8666 38.6077 28.3539 36.4479 31.286L36.4099 31.2787ZM21.7528 39.0733V27.5449C24.6473 27.6282 27.5001 28.24 30.1643 29.3488C28.5377 33.1982 25.8592 36.5371 22.4213 38.9996L21.7528 39.0733ZM19.7239 38.9248C16.2547 36.4873 13.5388 33.164 11.8749 29.3183C14.5271 28.2346 17.3594 27.6331 20.2329 27.5443V39.0727H19.8453C19.8129 39.0104 19.7725 38.953 19.7239 38.9018L19.7239 38.9248ZM1.99727 21.2565H8.56243C8.64311 23.7437 9.11178 26.2048 9.95257 28.5538C8.3773 29.3057 6.88948 30.2219 5.51508 31.2857C3.36328 28.3509 2.14012 24.8637 1.99727 21.2565ZM5.51546 9.74325C6.87056 10.7916 8.33464 11.6975 9.88433 12.4452C9.06689 14.8079 8.62353 17.2785 8.56958 19.7719H1.99728C2.14696 16.1623 3.37805 12.675 5.53815 9.74296L5.51546 9.74325ZM20.2334 1.95602V13.4844C17.3392 13.4015 14.4861 12.7896 11.8222 11.6805C13.4485 7.8311 16.127 4.49254 19.5649 2.02967L20.2334 1.95602ZM22.2623 2.10447C25.7319 4.5416 28.4474 7.86497 30.1113 11.71C27.4591 12.7941 24.6268 13.3953 21.7533 13.484V1.95566H22.1409C22.1729 2.01792 22.2136 2.07538 22.2623 2.12621L22.2623 2.10447ZM20.2334 19.7719H10.0897C10.15 17.4994 10.5546 15.2475 11.2903 13.0908C14.1257 14.2552 17.159 14.8921 20.2334 14.9691V19.7719ZM20.2334 21.2563V26.0595C17.1858 26.1549 14.1811 26.7914 11.3664 27.9378C10.6089 25.7843 10.184 23.5325 10.1049 21.2567L20.2334 21.2563ZM21.7529 21.2563L31.8966 21.2567C31.8366 23.5296 31.432 25.781 30.696 27.9378C27.8606 26.7734 24.8276 26.1364 21.7529 26.0595V21.2563ZM21.7529 19.7719L21.7533 14.9691C24.8013 14.8737 27.806 14.2375 30.6206 13.0908C31.3777 15.2446 31.803 17.4961 31.8818 19.7719H21.7529ZM33.4091 19.7719C33.3284 17.2847 32.8597 14.8239 32.0189 12.4749C33.5942 11.7227 35.082 10.8069 36.4564 9.74308C38.6135 12.676 39.8423 16.1629 39.9897 19.772L33.4091 19.7719ZM35.5213 8.56978C34.2631 9.54561 32.9035 10.3891 31.4643 11.0865C30.0101 7.74172 27.7994 4.76207 24.998 2.37134C29.1119 3.24142 32.8131 5.42181 35.5213 8.56978ZM16.6171 2.46046C13.9345 4.846 11.8249 7.78151 10.4396 11.0566C9.03172 10.3652 7.69999 9.53448 6.46554 8.57751C9.08945 5.52639 12.649 3.38169 16.6171 2.46046ZM6.46574 32.4587C7.72431 31.4829 9.08433 30.6393 10.5235 29.942C11.9773 33.2868 14.188 36.2664 16.9894 38.6571C12.8755 37.7871 9.17429 35.6067 6.46574 32.4587ZM25.3632 38.5758C28.0462 36.1906 30.1557 33.2547 31.5407 29.9792C32.9486 30.6707 34.2803 31.5017 35.5147 32.4587C32.8916 35.5055 29.3353 37.6472 25.3711 38.568L25.3632 38.5758Z"
                    fill="white"
                    stroke="#EAE2C3"
                  />
                </svg>
              </button>
            </div>

            <div className="lg:hidden flex items-center">
              <button
                onClick={toggleMobileMenu}
                className="text-white hover:text-[#D4AF37] focus:outline-none focus:text-white p-3 rounded-md transition-colors duration-200"
                aria-label="Toggle menu"
                aria-expanded={isMobileMenuOpen}
              >
                <span className="sr-only">Open main menu</span>
                <svg
                  className="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d={
                      isMobileMenuOpen
                        ? "M6 18L18 6M6 6l12 12"
                        : "M4 6h16M4 12h16M4 18h16"
                    }
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div
          className="lg:hidden bg-[#1A1A1A] rounded-b-2xl z-30 overflow-y-auto max-h-[calc(100vh-6rem)] border-t border-[#332A0C] fixed top-24 left-0 right-0 shadow-lg"
          id="mobile-menu"
          style={{
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
        >
          <div className="px-4 py-6 space-y-2">
            {navItems.map((item, index) => (
              <div
                key={index}
                className="block px-4 py-3 text-lg font-medium text-white hover:bg-[#2A2A2A] hover:text-[#D4AF37] rounded-lg transition-colors duration-200 cursor-default"
                onClick={closeMobileMenu}
              >
                {item}
              </div>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default React.memo(Navbar);
